import { Model } from '@/models/Model';
import { QueryClient, QueryKey } from '@tanstack/react-query';
import { CacheStrategy } from './CacheStrategy';
import { InfiniteCacheStrategy } from './list/InfiniteCacheStrategy';
import { SimpleCacheStrategy } from './list/SimpleListCacheStrategy';
import { SingleCacheStrategy } from './SingleCacheStrategy';

export enum CacheType {
  INFINITE = 'infinite',
  SINGLE = 'single',
  LIST = 'list',
}

class CacheStrategyFactory {
  static create<T extends Model>(
    type: CacheType,
    queryClient: QueryClient,
    queryKey: QueryKey,
  ): CacheStrategy<T> {
    switch (type) {
      case CacheType.INFINITE:
        return new InfiniteCacheStrategy<T>(queryClient, queryKey);
      case CacheType.SINGLE:
        return new SingleCacheStrategy<T>(queryClient, queryKey);
      case CacheType.LIST:
        return new SimpleCacheStrategy<T>(queryClient, queryKey);
      default:
        throw new Error(`Unsupported cache type: ${type}`);
    }
  }
}

export default CacheStrategyFactory;
